export default [
    {
        hidden: false,
        step: 1,
        name: 'StafetDonationStepOne',
        label: 'formStepLabel1',
        completed: false
    },
    {
        hidden: false,
        step: 2,
        name: 'StafetDonationStepTwo',
        label: 'formStepLabel2',
        completed: false
    },
    {
        hidden: true,
        step: 3,
        name: 'FormStepSubmitting',
        completed: false
    }
]
